import React, { useEffect } from 'react';
import { DropdownCollapse } from '@app/components/header/Header.styles';
import { useTranslation } from 'react-i18next';
import { LanguagePicker } from '../LanguagePicker/LanguagePicker';
import { LogoTitlePicker } from '../LogoTitlePicker/LogoTitlePicker';
import { NightModeSettings } from '../nightModeSettings/NightModeSettings';
import { ThemePicker } from '../ThemePicker/ThemePicker';
import { Button } from '@app/components/common/buttons/Button/Button';
import { useAppSelector } from '@app/hooks/reduxHooks';
import * as S from './SettingsOverlay.styles';
import { DashboardDayColorPicker } from '../DayColorPicker/DashboardDayColorPicker';
import { checkRoot } from '@app/services/localStorage.service';

export const SettingsOverlay: React.FC = ({ ...props }) => {
  const { t } = useTranslation();

  const { isPWASupported, event } = useAppSelector((state) => state.pwa);

  return (
    <S.SettingsOverlayMenu mode="inline" selectable={false} {...props}>
      <DropdownCollapse bordered={false} expandIconPosition="right" ghost defaultActiveKey="themePicker">
        {!['spa', 'fac', ''].includes(location.pathname.split('/')[1]) ? (
          <>
            {checkRoot() && (
              <DropdownCollapse.Panel header={t('header.changLogoTitle')} key="loggoTitlePicker">
                <LogoTitlePicker />
              </DropdownCollapse.Panel>
            )}
            <DropdownCollapse.Panel header={t('header.changDayColor')} key="dashboardDayColorPicker">
              <DashboardDayColorPicker />
            </DropdownCollapse.Panel>
          </>
        ) : null}

        <DropdownCollapse.Panel header={t('header.changeLanguage')} key="languagePicker">
          <LanguagePicker />
        </DropdownCollapse.Panel>
        <DropdownCollapse.Panel header={t('header.changeTheme')} key="themePicker">
          <ThemePicker />
        </DropdownCollapse.Panel>
        {/* <DropdownCollapse.Panel header={t('header.nightMode.title')} key="nightMode">
          <NightModeSettings />
        </DropdownCollapse.Panel> */}
      </DropdownCollapse>
      {isPWASupported && (
        <S.PwaInstallWrapper>
          <Button block type="primary" onClick={() => event && (event as BeforeInstallPromptEvent).prompt()}>
            {t('common.pwa')}
          </Button>
        </S.PwaInstallWrapper>
      )}
    </S.SettingsOverlayMenu>
  );
};
